import { useMutation } from '@tanstack/react-query'
import axiosClient from '../../axios'
import { IAnalysisMalaria } from '../../../types/ia-analysis'

/**
 * Analyse malaria directe sans créer de diagnostic
 * Envoie l'image directement au modèle IA
 */
interface DirectMalariaAnalysisResponse {
  analysis: IAnalysisMalaria
  imageUrl?: string
}

export const useDirectMalariaAnalysis = () => {
  const directAnalysis = useMutation({
    mutationKey: ['directMalariaAnalysis'],
    mutationFn: async (file: File): Promise<DirectMalariaAnalysisResponse> => {
      console.log('🔬 Calling malaria AI model with image:', file.name)

      const formData = new FormData()
      formData.append('image', file)

      try {
        const response = await axiosClient.post<DirectMalariaAnalysisResponse>(
          '/analysis/malaria/direct',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        console.log('✅ Malaria AI response:', response.data)
        return response.data
      } catch (error: any) {
        console.error('❌ Malaria AI error:', error.response?.status, error.response?.data)

        // Si l'endpoint n'existe pas (404), donner un message clair
        if (error.response?.status === 404) {
          throw new Error(
            'Backend endpoint /analysis/malaria/direct not implemented yet. ' +
            'Please check BACKEND_API_REQUIRED.md for implementation details.'
          )
        }

        throw error
      }
    },
  })
  return directAnalysis
}
